import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { PopupDefault, CloseButton } from "./ReusableComponents/PopupDefault";
import '../Styles/footer.scss';
import About from "./Popups/About";

function Footer() {
  const location = useLocation();
  const isHomepage = location.pathname.startsWith('/generator');
  const isShortPage = location.pathname === '/saved';
  const [showAboutPopup, setShowAboutPopup] = useState(false);

  return (
    <>
    <footer className={`footer ${isHomepage ? 'footer--homepage' : ''} ${isShortPage ? 'footer--hide' : ''}`}>
      <div className="footer-items">
        <a className="item" target="_blank" rel="noreferrer" href="https://forms.gle/Y58FMYsxAy99oAsp9">Feedback</a>
        <a className="item" target="_blank" rel="noreferrer" href="https://forms.gle/GY2ugb8ygEmAJ3KcA">Report a bug</a>
        <a className="item" href="mailto:colors@no61.app">Contact</a>
        <Link className="item" to="/privacy-policy">Privacy policy</Link>
        <a className="item" target="_blank" rel="noreferrer" href="https://www.instagram.com/no61.app?igsh=MXE4MzEyaWYxemdtTO==">Instagram</a>
        <button className="item" onClick={() => setShowAboutPopup(true)}>
          <svg className="about-icon" width={21} height={21} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
          </svg>
        </button>
        <p className="item item-disabled">Copyright© No61</p>
      </div>
    </footer>

    {
      showAboutPopup && (
        <PopupDefault onClose={() => setShowAboutPopup(false)}>
          <CloseButton onClose={() => setShowAboutPopup(false)} />
          <About />
        </PopupDefault>
      )}
    </>
  )
}

export default Footer